import { useTheme } from '@emotion/react';
import { AnimatePresence } from 'framer-motion';
import React, { FC, ReactElement } from 'react';
import { Arrow, useHover, useLayer } from 'react-laag';
import Icon from '../Icon';
import { Tooltip as Wrapper, Trigger } from './styles';

export interface TooltipProps {
    placement?: 'top-start' | 'top-center' | 'top-end' | 'bottom-start' | 'bottom-center' | 'bottom-end';
    trigger?: ReactElement; // TODO: custom trigger
}

const Tooltip: FC<TooltipProps> = ({ children, placement, trigger }) => {
    const theme = useTheme();
    const [isOpen, hoverProps] = useHover({ delayEnter: 100, delayLeave: 300 });
    const { triggerProps, layerProps, arrowProps, renderLayer } = useLayer({
        isOpen,
        placement: placement ? placement : 'bottom-end',
        triggerOffset: 8
    });

    return (
        <>
            <Trigger {...triggerProps} {...hoverProps}>
                <Icon name="info" color={theme.greys[500]} size={1.25} />
            </Trigger>
            {renderLayer(
                <AnimatePresence>
                    {isOpen && (
                        <Wrapper {...layerProps}>
                            {children}
                            <Arrow {...arrowProps} size={6} />
                        </Wrapper>
                    )}
                </AnimatePresence>
            )}
        </>
    );
};

export default Tooltip;
